module.exports = __webpack_public_path__ + "static/img/cjfw-companyProfile.3f9545d0.png";